import Stack from '@mui/material/Stack';

import { type PartnerCampaign } from '@/api/routes/partners/partners.campaigns.api';
import Chip from '@/components/Chip';
import { campaignStatusLabel } from '@/domain/offers/utils';
import { useTranslate } from '@/state/i18n';

interface Props {
  campaigns: PartnerCampaign[];
  selectedId: string;
  onSelect: (campaign: PartnerCampaign) => void;
}

/** One chip per campaign: "Avaliação de hidratação · No ar". */
const CampaignPicker = ({ campaigns, selectedId, onSelect }: Props) => {
  const t = useTranslate('domain.results.components.CampaignPicker');

  return (
    <Stack direction="row" gap={1} flexWrap="wrap" role="radiogroup" aria-label={t('label')}>
      {campaigns.map((campaign) => {
        const selected = campaign.id === selectedId;
        return (
          <Chip
            key={campaign.id}
            role="radio"
            aria-checked={selected}
            size="xsmall"
            label={`${campaign.offer.title} · ${campaignStatusLabel[campaign.status]}`}
            color={selected ? 'dark' : 'neutral'}
            variant={selected ? 'solid' : 'outline'}
            onClick={() => onSelect(campaign)}
          />
        );
      })}
    </Stack>
  );
};

export default CampaignPicker;
